import {
  CarIcon,
  CirclePower,
  FuelIcon,
  Layers2Icon,
  LightbulbIcon,
  LucideIcon,
} from "lucide-react";

export interface MenuItem {
  name: string;
  href: string;
  icon: LucideIcon | null;
  roles?: string[];
}

export const coefficientsNavigation: MenuItem[] = [
  {
    name: "menu.categories",
    href: "/settings/categories",
    icon: Layers2Icon,
    roles: ["admin"],
  },
  {
    name: "menu.fuel-types",
    href: "/settings/fuel-types",
    icon: FuelIcon,
    roles: ["admin"],
  },
  {
    name: "menu.vehicle-types",
    href: "/settings/vehicle-types",
    icon: CarIcon,
    roles: ["admin"],
  },
  {
    name: "menu.comercializadoras",
    href: "/settings/comercializadoras",
    icon: LightbulbIcon,
    roles: ["admin"],
  },
];
